import { LocalizedContent } from '@/types/regional';

export const translations: LocalizedContent = {
  // Navigation & Steps
  'onboarding.step': {
    'en-US': 'Step {step} of {total}',
    'en-GB': 'Step {step} of {total}',
    'de-DE': 'Schritt {step} von {total}',
    'fr-FR': 'Étape {step} sur {total}',
    'es-ES': 'Paso {step} de {total}',
    'it-IT': 'Passo {step} di {total}',
    'pt-PT': 'Passo {step} de {total}',
    'nl-NL': 'Stap {step} van {total}',
    'ja-JP': 'ステップ {step} / {total}',
    'ko-KR': '{total} 단계 중 {step} 단계',
    'zh-CN': '第 {step} 步，共 {total} 步',
    'ru-RU': 'Шаг {step} из {total}',
    'hi-IN': 'चरण {step} का {total}',
    'ar-SA': 'الخطوة {step} من {total}',
    'tr-TR': '{total} adımın {step}. adımı'
  },

  // Buttons
  'button.next': {
    'en-US': 'Next',
    'en-GB': 'Next',
    'de-DE': 'Weiter',
    'fr-FR': 'Suivant',
    'es-ES': 'Siguiente',
    'it-IT': 'Avanti',
    'pt-PT': 'Próximo',
    'nl-NL': 'Volgende',
    'ja-JP': '次へ',
    'ko-KR': '다음',
    'zh-CN': '下一步',
    'ru-RU': 'Далее',
    'hi-IN': 'अगला',
    'ar-SA': 'التالي',
    'tr-TR': 'İleri'
  },

  'button.previous': {
    'en-US': 'Previous',
    'en-GB': 'Previous',
    'de-DE': 'Zurück',
    'fr-FR': 'Précédent',
    'es-ES': 'Anterior',
    'it-IT': 'Indietro',
    'pt-PT': 'Anterior',
    'nl-NL': 'Vorige',
    'ja-JP': '戻る',
    'ko-KR': '이전',
    'zh-CN': '上一步',
    'ru-RU': 'Назад',
    'hi-IN': 'पिछला',
    'ar-SA': 'السابق',
    'tr-TR': 'Geri'
  },

  'button.save': {
    'en-US': 'Save',
    'en-GB': 'Save',
    'de-DE': 'Speichern',
    'fr-FR': 'Enregistrer',
    'es-ES': 'Guardar',
    'it-IT': 'Salva',
    'pt-PT': 'Guardar',
    'nl-NL': 'Opslaan',
    'ja-JP': '保存',
    'ko-KR': '저장',
    'zh-CN': '保存',
    'ru-RU': 'Сохранить',
    'hi-IN': 'सेव करें',
    'ar-SA': 'حفظ',
    'tr-TR': 'Kaydet'
  },

  'button.cancel': {
    'en-US': 'Cancel',
    'en-GB': 'Cancel',
    'de-DE': 'Abbrechen',
    'fr-FR': 'Annuler',
    'es-ES': 'Cancelar',
    'it-IT': 'Annulla',
    'pt-PT': 'Cancelar',
    'nl-NL': 'Annuleren',
    'ja-JP': 'キャンセル',
    'ko-KR': '취소',
    'zh-CN': '取消',
    'ru-RU': 'Отмена',
    'hi-IN': 'रद्द करें',
    'ar-SA': 'إلغاء',
    'tr-TR': 'İptal'
  },

  // Backup Configuration
  'backup.title': {
    'en-US': 'Backup Configuration',
    'en-GB': 'Backup Configuration',
    'de-DE': 'Backup-Konfiguration',
    'fr-FR': 'Configuration de sauvegarde',
    'es-ES': 'Configuración de respaldo',
    'it-IT': 'Configurazione backup',
    'pt-PT': 'Configuração de backup',
    'nl-NL': 'Backup configuratie',
    'ja-JP': 'バックアップ設定',
    'ko-KR': '백업 구성',
    'zh-CN': '备份配置',
    'ru-RU': 'Конфигурация резервного копирования',
    'hi-IN': 'बैकअप कॉन्फ़िगरेशन',
    'ar-SA': 'تكوين النسخ الاحتياطي',
    'tr-TR': 'Yedekleme Yapılandırması'
  },

  'backup.frequency.daily': {
    'en-US': 'Daily',
    'en-GB': 'Daily',
    'de-DE': 'Täglich',
    'fr-FR': 'Quotidien',
    'es-ES': 'Diario',
    'it-IT': 'Giornaliero',
    'pt-PT': 'Diário',
    'nl-NL': 'Dagelijks',
    'ja-JP': '毎日',
    'ko-KR': '매일',
    'zh-CN': '每日',
    'ru-RU': 'Ежедневно',
    'hi-IN': 'दैनिक',
    'ar-SA': 'يومي',
    'tr-TR': 'Günlük'
  },

  'backup.frequency.weekly': {
    'en-US': 'Weekly',
    'en-GB': 'Weekly',
    'de-DE': 'Wöchentlich',
    'fr-FR': 'Hebdomadaire',
    'es-ES': 'Semanal',
    'it-IT': 'Settimanale',
    'pt-PT': 'Semanal',
    'nl-NL': 'Wekelijks',
    'ja-JP': '毎週',
    'ko-KR': '매주',
    'zh-CN': '每周',
    'ru-RU': 'Еженедельно',
    'hi-IN': 'साप्ताहिक',
    'ar-SA': 'أسبوعي',
    'tr-TR': 'Haftalık'
  },

  'backup.frequency.monthly': {
    'en-US': 'Monthly',
    'en-GB': 'Monthly',
    'de-DE': 'Monatlich',
    'fr-FR': 'Mensuel',
    'es-ES': 'Mensual',
    'it-IT': 'Mensile',
    'pt-PT': 'Mensal',
    'nl-NL': 'Maandelijks',
    'ja-JP': '毎月',
    'ko-KR': '매월',
    'zh-CN': '每月',
    'ru-RU': 'Ежемесячно',
    'hi-IN': 'मासिक',
    'ar-SA': 'شهري',
    'tr-TR': 'Aylık'
  },

  // Loading States
  'loading.saving': {
    'en-US': 'Saving...',
    'en-GB': 'Saving...',
    'de-DE': 'Speichern...',
    'fr-FR': 'Enregistrement...',
    'es-ES': 'Guardando...',
    'it-IT': 'Salvataggio...',
    'pt-PT': 'Guardando...',
    'nl-NL': 'Opslaan...',
    'ja-JP': '保存中...',
    'ko-KR': '저장 중...',
    'zh-CN': '保存中...',
    'ru-RU': 'Сохранение...',
    'hi-IN': 'सेव कर रहे हैं...',
    'ar-SA': 'جاري الحفظ...',
    'tr-TR': 'Kaydediliyor...'
  },

  'loading.testing': {
    'en-US': 'Testing connection...',
    'en-GB': 'Testing connection...',
    'de-DE': 'Verbindung testen...',
    'fr-FR': 'Test de connexion...',
    'es-ES': 'Probando conexión...',
    'it-IT': 'Test connessione...',
    'pt-PT': 'Testando conexão...',
    'nl-NL': 'Verbinding testen...',
    'ja-JP': '接続をテスト中...',
    'ko-KR': '연결 테스트 중...',
    'zh-CN': '测试连接中...',
    'ru-RU': 'Тестирование соединения...',
    'hi-IN': 'कनेक्शन टेस्ट कर रहे हैं...',
    'ar-SA': 'اختبار الاتصال...',
    'tr-TR': 'Bağlantı test ediliyor...'
  },

  // Error Messages
  'error.required': {
    'en-US': 'This field is required',
    'en-GB': 'This field is required',
    'de-DE': 'Dieses Feld ist erforderlich',
    'fr-FR': 'Ce champ est obligatoire',
    'es-ES': 'Este campo es obligatorio',
    'it-IT': 'Questo campo è obbligatorio',
    'pt-PT': 'Este campo é obrigatório',
    'nl-NL': 'Dit veld is verplicht',
    'ja-JP': 'この項目は必須です',
    'ko-KR': '이 필드는 필수입니다',
    'zh-CN': '此字段为必填项',
    'ru-RU': 'Это поле обязательно',
    'hi-IN': 'यह फ़ील्ड आवश्यक है',
    'ar-SA': 'هذا الحقل مطلوب',
    'tr-TR': 'Bu alan zorunludur'
  },

  'error.invalid.email': {
    'en-US': 'Please enter a valid email address',
    'en-GB': 'Please enter a valid email address',
    'de-DE': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    'fr-FR': 'Veuillez saisir une adresse e-mail valide',
    'es-ES': 'Por favor ingrese una dirección de correo válida',
    'it-IT': 'Inserisci un indirizzo email valido',
    'pt-PT': 'Por favor insira um endereço de email válido',
    'nl-NL': 'Voer een geldig e-mailadres in',
    'ja-JP': '有効なメールアドレスを入力してください',
    'ko-KR': '유효한 이메일 주소를 입력하세요',
    'zh-CN': '请输入有效的电子邮件地址',
    'ru-RU': 'Пожалуйста, введите действительный адрес электронной почты',
    'hi-IN': 'कृपया एक वैध ईमेल पता दर्ज करें',
    'ar-SA': 'يرجى إدخال عنوان بريد إلكتروني صالح',
    'tr-TR': 'Lütfen geçerli bir e-posta adresi girin'
  },

  // Success Messages
  'success.saved': {
    'en-US': 'Configuration saved successfully',
    'en-GB': 'Configuration saved successfully',
    'de-DE': 'Konfiguration erfolgreich gespeichert',
    'fr-FR': 'Configuration enregistrée avec succès',
    'es-ES': 'Configuración guardada exitosamente',
    'it-IT': 'Configurazione salvata con successo',
    'pt-PT': 'Configuração guardada com sucesso',
    'nl-NL': 'Configuratie succesvol opgeslagen',
    'ja-JP': '設定が正常に保存されました',
    'ko-KR': '구성이 성공적으로 저장되었습니다',
    'zh-CN': '配置保存成功',
    'ru-RU': 'Конфигурация успешно сохранена',
    'hi-IN': 'कॉन्फ़िगरेशन सफलतापूर्वक सेव हो गई',
    'ar-SA': 'تم حفظ التكوين بنجاح',
    'tr-TR': 'Yapılandırma başarıyla kaydedildi'
  },

  // Additional translations
  'button.skip': {
    'en-US': 'Skip for now',
    'de-DE': 'Vorerst überspringen',
    'fr-FR': 'Passer pour le moment',
    'es-ES': 'Omitir por ahora'
  },

  'backup.frequency.hourly': {
    'en-US': 'Every Hour',
    'de-DE': 'Stündlich',
    'fr-FR': 'Toutes les heures',
    'es-ES': 'Cada hora'
  },

  'error.name.short': {
    'en-US': 'Name must be at least 2 characters',
    'de-DE': 'Name muss mindestens 2 Zeichen haben',
    'fr-FR': 'Le nom doit contenir au moins 2 caractères',
    'es-ES': 'El nombre debe tener al menos 2 caracteres'
  },

  'success.connection': {
    'en-US': 'connection successful',
    'de-DE': 'Verbindung erfolgreich',
    'fr-FR': 'connexion réussie',
    'es-ES': 'conexión exitosa'
  },

  'error.connection': {
    'en-US': 'Connection failed',
    'de-DE': 'Verbindung fehlgeschlagen',
    'fr-FR': 'Échec de la connexion',
    'es-ES': 'Conexión fallida'
  },

  'success.exported': {
    'en-US': 'Configuration exported successfully',
    'de-DE': 'Konfiguration erfolgreich exportiert',
    'fr-FR': 'Configuration exportée avec succès',
    'es-ES': 'Configuración exportada exitosamente'
  },

  'success.imported': {
    'en-US': 'Configuration imported successfully',
    'de-DE': 'Konfiguration erfolgreich importiert',
    'fr-FR': 'Configuration importée avec succès',
    'es-ES': 'Configuración importada exitosamente'
  },

  'error.invalid.file': {
    'en-US': 'Invalid configuration file',
    'de-DE': 'Ungültige Konfigurationsdatei',
    'fr-FR': 'Fichier de configuration invalide',
    'es-ES': 'Archivo de configuración inválido'
  },

  'error.parse.failed': {
    'en-US': 'Failed to parse configuration file',
    'de-DE': 'Konfigurationsdatei konnte nicht analysiert werden',
    'fr-FR': 'Échec de l\'analyse du fichier de configuration',
    'es-ES': 'Error al analizar el archivo de configuración'
  },

  'loading.launching': {
    'en-US': 'Launching...',
    'de-DE': 'Wird gestartet...',
    'fr-FR': 'Lancement...',
    'es-ES': 'Iniciando...'
  },

  'loading.running': {
    'en-US': 'Running...',
    'de-DE': 'Läuft...',
    'fr-FR': 'En cours...',
    'es-ES': 'Ejecutando...'
  },

  'button.test.connection': {
    'en-US': 'Test Connection',
    'de-DE': 'Verbindung testen',
    'fr-FR': 'Tester la connexion',
    'es-ES': 'Probar conexión'
  },

  'button.dry.run': {
    'en-US': 'Dry Run',
    'de-DE': 'Testlauf',
    'fr-FR': 'Test à blanc',
    'es-ES': 'Prueba en seco'
  },

  'button.activate.backup': {
    'en-US': 'Activate Backup Protection',
    'de-DE': 'Backup-Schutz aktivieren',
    'fr-FR': 'Activer la protection de sauvegarde',
    'es-ES': 'Activar protección de respaldo'
  },

  'button.skip.now': {
    'en-US': 'Skip for now',
    'de-DE': 'Vorerst überspringen',
    'fr-FR': 'Passer pour le moment',
    'es-ES': 'Omitir por ahora'
  },

  'button.launch.dashboard': {
    'en-US': 'Launch Dashboard',
    'de-DE': 'Dashboard starten',
    'fr-FR': 'Lancer le tableau de bord',
    'es-ES': 'Lanzar panel de control'
  },

  'error.dry.run': {
    'en-US': 'Dry run failed',
    'de-DE': 'Testlauf fehlgeschlagen',
    'fr-FR': 'Test à blanc échoué',
    'es-ES': 'Prueba en seco fallida'
  },

  'success.setup.complete': {
    'en-US': 'Setup complete! Redirecting to dashboard...',
    'de-DE': 'Setup abgeschlossen! Weiterleitung zum Dashboard...',
    'fr-FR': 'Configuration terminée ! Redirection vers le tableau de bord...',
    'es-ES': '¡Configuración completa! Redirigiendo al panel...'
  },

  'cost.storage': {
    'en-US': 'Storage',
    'de-DE': 'Speicher',
    'fr-FR': 'Stockage',
    'es-ES': 'Almacenamiento'
  },

  'cost.transfer': {
    'en-US': 'Transfer',
    'de-DE': 'Übertragung',
    'fr-FR': 'Transfert',
    'es-ES': 'Transferencia'
  },

  'cost.monthly': {
    'en-US': 'Monthly',
    'de-DE': 'Monatlich',
    'fr-FR': 'Mensuel',
    'es-ES': 'Mensual'
  },

  'error.invalid.phone': {
    'en-US': 'Please enter a valid phone number',
    'en-GB': 'Please enter a valid phone number',
    'de-DE': 'Bitte geben Sie eine gültige Telefonnummer ein',
    'fr-FR': 'Veuillez saisir un numéro de téléphone valide',
    'es-ES': 'Por favor ingrese un número de teléfono válido',
    'it-IT': 'Inserisci un numero di telefono valido',
    'pt-PT': 'Por favor insira um número de telefone válido',
    'nl-NL': 'Voer een geldig telefoonnummer in',
    'ja-JP': '有効な電話番号を入力してください',
    'ko-KR': '유효한 전화번호를 입력하세요',
    'zh-CN': '请输入有效的电话号码',
    'ru-RU': 'Пожалуйста, введите действительный номер телефона',
    'hi-IN': 'कृपया एक वैध फोन नंबर दर्ज करें',
    'ar-SA': 'يرجى إدخال رقم هاتف صالح',
    'tr-TR': 'Lütfen geçerli bir telefon numarası girin'
  },

  'storage.type': {
    'en-US': 'Storage type',
    'de-DE': 'Speichertyp',
    'fr-FR': 'Type de stockage',
    'es-ES': 'Tipo de almacenamiento'
  },

  'storage.local': {
    'en-US': 'Local Storage',
    'de-DE': 'Lokaler Speicher',
    'fr-FR': 'Stockage local',
    'es-ES': 'Almacenamiento local'
  },

  'tooltip.full': {
    'en-US': 'Complete backup of all data. Slower but independent.',
    'de-DE': 'Vollständige Sicherung aller Daten. Langsamer aber unabhängig.',
    'fr-FR': 'Sauvegarde complète de toutes les données. Plus lent mais indépendant.',
    'es-ES': 'Copia de seguridad completa de todos los datos. Más lento pero independiente.'
  },

  'tooltip.retention': {
    'en-US': 'How long to keep backups. Longer = more storage cost but better recovery options.',
    'de-DE': 'Wie lange Sicherungen aufbewahrt werden. Länger = mehr Speicherkosten aber bessere Wiederherstellungsoptionen.',
    'fr-FR': 'Combien de temps conserver les sauvegardes. Plus long = plus de coûts de stockage mais meilleures options de récupération.',
    'es-ES': 'Cuánto tiempo mantener copias. Más tiempo = más costo de almacenamiento pero mejores opciones de recuperación.'
  },

  'placeholder.company.name': {
    'en-US': 'Acme Corporation',
    'de-DE': 'Musterfirma GmbH',
    'fr-FR': 'Société Exemple',
    'es-ES': 'Empresa Ejemplo'
  },

  'placeholder.profile.name': {
    'en-US': 'John Doe',
    'de-DE': 'Max Mustermann',
    'fr-FR': 'Jean Dupont',
    'es-ES': 'Juan Pérez'
  },

  'placeholder.profile.role': {
    'en-US': 'Database Administrator',
    'de-DE': 'Datenbankadministrator',
    'fr-FR': 'Administrateur de base de données',
    'es-ES': 'Administrador de base de datos'
  },

  'placeholder.email': {
    'en-US': 'email@company.com',
    'de-DE': 'email@firma.de',
    'fr-FR': 'email@entreprise.fr',
    'es-ES': 'email@empresa.com'
  },

  'cost.size': {
    'en-US': 'Size',
    'de-DE': 'Größe',
    'fr-FR': 'Taille',
    'es-ES': 'Tamaño'
  },

  'select.industry': {
    'en-US': 'Select industry',
    'de-DE': 'Branche auswählen',
    'fr-FR': 'Sélectionner le secteur',
    'es-ES': 'Seleccionar industria'
  },

  // Step titles
  'step.title.company': {
    'en-US': 'Company Information',
    'en-GB': 'Company Information',
    'de-DE': 'Unternehmensinformationen',
    'fr-FR': 'Informations sur l\'entreprise',
    'es-ES': 'Información de la empresa',
    'it-IT': 'Informazioni aziendali',
    'pt-PT': 'Informações da empresa',
    'nl-NL': 'Bedrijfsinformatie',
    'ja-JP': '会社情報',
    'ko-KR': '회사 정보',
    'zh-CN': '公司信息',
    'ru-RU': 'Информация о компании',
    'hi-IN': 'कंपनी की जानकारी',
    'ar-SA': 'معلومات الشركة',
    'tr-TR': 'Şirket Bilgileri'
  },

  'step.title.profile': {
    'en-US': 'Profile Setup',
    'en-GB': 'Profile Setup',
    'de-DE': 'Profil-Einrichtung',
    'fr-FR': 'Configuration du profil',
    'es-ES': 'Configuración del perfil',
    'it-IT': 'Configurazione profilo',
    'pt-PT': 'Configuração do perfil',
    'nl-NL': 'Profiel instellen',
    'ja-JP': 'プロファイル設定',
    'ko-KR': '프로필 설정',
    'zh-CN': '个人资料设置',
    'ru-RU': 'Настройка профиля',
    'hi-IN': 'प्रोफ़ाइल सेटअप',
    'ar-SA': 'إعداد الملف الشخصي',
    'tr-TR': 'Profil Kurulumu'
  },

  'step.title.backup': {
    'en-US': 'Backup Configuration',
    'en-GB': 'Backup Configuration',
    'de-DE': 'Backup-Konfiguration',
    'fr-FR': 'Configuration de sauvegarde',
    'es-ES': 'Configuración de respaldo',
    'it-IT': 'Configurazione backup',
    'pt-PT': 'Configuração de backup',
    'nl-NL': 'Backup configuratie',
    'ja-JP': 'バックアップ設定',
    'ko-KR': '백업 구성',
    'zh-CN': '备份配置',
    'ru-RU': 'Конфигурация резервного копирования',
    'hi-IN': 'बैकअप कॉन्फ़िगरेशन',
    'ar-SA': 'تكوين النسخ الاحتياطي',
    'tr-TR': 'Yedekleme Yapılandırması'
  },

  'step.title.review': {
    'en-US': 'Review & Launch',
    'en-GB': 'Review & Launch',
    'de-DE': 'Überprüfen & Starten',
    'fr-FR': 'Révision et lancement',
    'es-ES': 'Revisar y lanzar',
    'it-IT': 'Revisione e avvio',
    'pt-PT': 'Revisar e lançar',
    'nl-NL': 'Beoordelen en starten',
    'ja-JP': '確認と開始',
    'ko-KR': '검토 및 시작',
    'zh-CN': '审查和启动',
    'ru-RU': 'Проверка и запуск',
    'hi-IN': 'समीक्षा और लॉन्च',
    'ar-SA': 'المراجعة والإطلاق',
    'tr-TR': 'İnceleme ve Başlatma'
  },

  'select.company.size': {
    'en-US': 'Select company size',
    'de-DE': 'Unternehmensgröße auswählen',
    'fr-FR': 'Sélectionner la taille de l\'entreprise',
    'es-ES': 'Seleccionar tamaño de empresa'
  },

  'bulk.apply.all': {
    'en-US': 'Apply to all modules',
    'de-DE': 'Auf alle Module anwenden',
    'fr-FR': 'Appliquer à tous les modules',
    'es-ES': 'Aplicar a todos los módulos'
  },

  'bulk.copy.schedule': {
    'en-US': 'Copy schedule to all',
    'de-DE': 'Zeitplan auf alle kopieren',
    'fr-FR': 'Copier le planning sur tous',
    'es-ES': 'Copiar horario a todos'
  },

  'bulk.copy.storage': {
    'en-US': 'Copy storage to all',
    'de-DE': 'Speicher auf alle kopieren',
    'fr-FR': 'Copier le stockage sur tous',
    'es-ES': 'Copiar almacenamiento a todos'
  },

  'database.size.calculating': {
    'en-US': 'Calculating size...',
    'de-DE': 'Größe wird berechnet...',
    'fr-FR': 'Calcul de la taille...',
    'es-ES': 'Calculando tamaño...'
  },

  'error.schedule.calculation': {
    'en-US': 'Error calculating next run time',
    'de-DE': 'Fehler bei der Berechnung der nächsten Laufzeit',
    'fr-FR': 'Erreur lors du calcul de la prochaine exécution',
    'es-ES': 'Error calculando próxima ejecución'
  },

  'summary.selected': {
    'en-US': 'Selected',
    'de-DE': 'Ausgewählt',
    'fr-FR': 'Sélectionné',
    'es-ES': 'Seleccionado'
  },

  'summary.enabled': {
    'en-US': 'Enabled',
    'de-DE': 'Aktiviert',
    'fr-FR': 'Activé',
    'es-ES': 'Habilitado'
  },

  'summary.days': {
    'en-US': 'Days',
    'de-DE': 'Tage',
    'fr-FR': 'Jours',
    'es-ES': 'Días'
  },
};

export class I18n {
  constructor(private locale: string) {}

  t(key: string, params?: Record<string, any>): string {
    const translation = translations[key]?.[this.locale] || translations[key]?.['en-US'] || key;
    
    if (!params) return translation;
    
    return Object.entries(params).reduce((text, [param, value]) => {
      return text.replace(new RegExp(`\\{${param}\\}`, 'g'), String(value));
    }, translation);
  }

  static getSupportedLocales(): string[] {
    return [
      'en-US', 'en-GB', 'de-DE', 'fr-FR', 'es-ES', 'it-IT', 'pt-PT', 'nl-NL',
      'ja-JP', 'ko-KR', 'zh-CN', 'ru-RU', 'hi-IN', 'ar-SA', 'tr-TR'
    ];
  }
}